import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {makeStyles} from 'tss-react/mui';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import NotesIcon from '@mui/icons-material/Notes';
import MUIDataTable from 'mui-datatables';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
//DS
import {queryCliente} from './queries';
import {openMsg, loadingModal} from 'src/redux-app';
import {SelectPlus, DialogBase, hooks, CardObjeto, Localizacion} from 'lib.front';
import {transformacion} from 'lib.common';
import {urlsCrm} from '../../../config/keys';
import GestionarLicencia from '../../procesos/modificarLicencia';
//Components
import CodeWithButtonCopy from './componentes/codeWithButtonCopy';
import CustomSearch from './componentes/customSearch';
import Footer from './componentes/footer';
import palette from 'src/theme/palette';

const {denominacionCliente} = transformacion;
const {useApolloLazyQ} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2),
      width: '95%'
   },
   customSelectStyles: {
      maxWidth: 500,
   }
}));

function ListarCliente(props) {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   const [searchText, setSearchText] = useState('');

   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }

   //Estados
   const [cliente, setCliente] = useState(null);

   useEffect(() => {
      if (cliente) buscarLlavesPorCliente();
   }, [cliente]);

   //Data de cliente
   function buscarLlavesPorCliente() {
      if (cliente && cliente.value !== '') {
         getCliente({variables: {codigoCliente: cliente.value}});
      } else {
         getCliente({variables: {codigoCliente: '*'}});
      }
   }
   function procesarCliente(data) {
      //console.log(data);
   }
   const [getCliente, {data: dataCliente}] = useApolloLazyQ(queryCliente, {
      callbackProcesarData: procesarCliente,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   useEffect(() => {
      const firstTable = document.querySelector('.MuiTable-root');
      if (firstTable) {
         firstTable.classList.add('firstMuiTable');
      }
   }, [dataCliente]);

   // GESTIONAR LICENCIA
   const [codigoActivacion, setCodigoActivacion] = useState('');
   function closeModalGestionarLicencia() {
      setCodigoActivacion('');
   }
   function closeModalGestionarLicenciaSucces() {
      buscarLlavesPorCliente();
      closeModalGestionarLicencia();
   }
   //INFORMACION ADICIONAL
   const [infoAdicional, setInfoAdicional] = useState(null);
   function closeModalInfoAdicional() {
      setInfoAdicional(null);
   }
   const configuracionInfoAdicional = [
      {
         name: 'ide',
         label: 'Ide',
         options: {
            display: 'false'
         }
      },
      {
         name: 'mac',
         label: 'Mac',
         options: {
            display: 'false',
            customBodyRender: (value, tableMeta, updateValue) => {
               return (
                  <div
                     style={{
                        maxWidth: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                     }}
                  >
                     {value}
                  </div>
               );
            }
         }
      },
      {
         name: 'cpu',
         label: 'Cpu',
         options: {
            display: 'false'
         }
      },
      {
         name: 'placa',
         label: 'Placa',
         options: {
            display: 'false'
         }
      },
      {
         name: 'bios',
         label: 'Bios',
         options: {
            display: 'false'
         }
      },
      {
         name: 'sisoper',
         label: 'Sisoper',
         options: {
            display: 'false'
         }
      },
      {
         name: 'ram',
         label: 'Ram',
         options: {
            display: 'false'
         }
      },
      {
         name: 'chip',
         label: 'Chip',
         options: {
            display: 'false'
         }
      }
   ];
   // CONFIGURACION TABLA

   function codeWithButtonCopy(info, codHash, tableMeta) {
      const getColor = codHash => {
         if (codHash === 'ANULADO') {
            return palette.error.main;
         } else if (codHash) {
            return palette.success.main;
         } else {
            return palette.info.main;

         }
      };
      return <CodeWithButtonCopy info={info} color={getColor(codHash)} />;
   }
   function ButtonAction(info) {
      return (
         <>
            <Grid container spacing={1}>
               <Grid item xs={6}>
                  <Tooltip title="Información Adicional">
                     <IconButton
                        onClick={() => {
                           setInfoAdicional(info);
                        }}
                        variant="contained"
                        size="small"
                     >
                        <NotesIcon />
                     </IconButton>
                  </Tooltip>
               </Grid>

               <Grid item xs={6}>
                  <Tooltip title="Modificar Licencia">
                     <IconButton
                        onClick={() => {
                           setCodigoActivacion(info.codigo);
                        }}
                        variant="contained"
                        size="small"
                     >
                        <EditOutlinedIcon />
                     </IconButton>
                  </Tooltip>
               </Grid>
            </Grid>
         </>
      );
   }

   const column = [
      {
         name: 'documento',
         label: 'Documento',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'codigo',
         label: 'Código Activación',
         options: {
            filter: true,
            display: 'true',
            customBodyRender: (value, tableMeta, updateValue) => {
               return codeWithButtonCopy(value, tableMeta.rowData[13], tableMeta);
            }
         }
      },
      {
         name: 'producto',
         label: 'Producto',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'fechaExpiracion',
         label: 'Fecha de Expiración',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'usuario',
         label: 'Usuario',
         options: {
            filter: true,
            display: 'true'
         }
      },
      ...configuracionInfoAdicional,
      {
         name: 'codHash',
         label: 'codHash',
         options: {
            display: 'excluded'
         }
      },
      {
         name: '',
         options: {
            filter: false,
            sort: false,
            empty: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return ButtonAction({
                  codigo: tableMeta.rowData[1],
                  ide: tableMeta.rowData[5],
                  mac: tableMeta.rowData[6],
                  cpu: tableMeta.rowData[7],
                  placa: tableMeta.rowData[8],
                  bios: tableMeta.rowData[9],
                  sisoper: tableMeta.rowData[10],
                  ram: tableMeta.rowData[11],
                  chip: tableMeta.rowData[12]
               });
            }
         }
      }
   ];

   const options = {
      filterType: 'dropdown',
      selectableRows: 'none',
      responsive: 'standard',
      pagination: true,
      searchOpen: true,
      search: false,
      elevation: 0,
      rowsPerPage: 5,
      rowsPerPageOptions: [5, 10, 15, 100],
      rowHover: false,
      print: false,
      download: false,
      viewColumns: true,
      filter: true,
      searchPlaceholder: 'Buscar',
      customSearchRender: (searchText, handleSearch, hideSearch, options) => {
         return (
            <CustomSearch searchText={searchText} handleSearch={handleSearch} options={options} />
         );
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
         return (
            <Footer
               count={count}
               page={page}
               rowsPerPage={rowsPerPage}
               changeRowsPerPage={changeRowsPerPage}
               changePage={changePage}
            />
         );
      },
      textLabels: Localizacion.muiDataTables.ES
   };

   const components = {
      icons: {
         ViewColumnIcon: ViewWeekOutlinedIcon
      }
   };

   return (
      <Container className={cx('containerbox', classes.container)}>
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Listado de licencias de clientes
               </Typography>
            </Grid>
            <Grid container item xs={12}>
               <Grid container item xs={12} spacing={1} alignItems="center">
                  <Grid item xs={12}>
                     <SelectPlus
                        url={urlsCrm.graph}
                        name="cliente"
                        label="RUC"
                        entidad="clientes"
                        campos={[
                           'codigo',
                           'nombre',
                           'apPaterno',
                           'apMaterno',
                           'razonSocial',
                           'nroDoc'
                        ]}
                        value={cliente}
                        onChange={elegido => {
                           setCliente(elegido);
                        }}
                        genId={registro => {
                           return registro.nroDoc;
                        }}
                        genLabel={denominacionCliente}
                        InputLabelProps={{shrink: true}}
                        variant="outlined"
                        margin="dense"
                        isClearable
                        excesoElementos
                        placeholder="Elija un cliente:"
                        className={classes.customSelectStyles}
                     />
                  </Grid>
               </Grid>
               <Grid className={classes.container} item xs={12}>
                  {dataCliente !== undefined && dataCliente !== null && (
                        <MUIDataTable
                           data={dataCliente.llavesDetalle}
                           columns={column}
                           options={options}
                           components={components}
                        />
                  )}
               </Grid>
            </Grid>
         </Grid>
         <DialogBase
            open={codigoActivacion !== ''}
            onClose={closeModalGestionarLicencia}
            maxWidth={false}
         >
            <GestionarLicencia
               codigoActivacion={codigoActivacion}
               onSuccessCallback={closeModalGestionarLicenciaSucces}
               onCloseCallback={closeModalGestionarLicencia}
            />
         </DialogBase>
         <DialogBase
            open={infoAdicional !== null}
            onClose={closeModalInfoAdicional}
            maxWidth={false}
         >
            <CardObjeto
               value={infoAdicional}
               configuracion={configuracionInfoAdicional}
               titulo={`Llave: ${infoAdicional && infoAdicional.codigo}`}
            />
         </DialogBase>
      </Container>
   );
}

export default ListarCliente;
